module.exports = __webpack_public_path__ + "static/media/Medea.fcd3998a.jpg";